import { createSlice } from '@reduxjs/toolkit';
import { Log, LogListParams } from '../../models/log.model';

interface LogState {
    data: Log[];
    logListParams: LogListParams;
    loading: boolean;
}

const initialState: LogState = {
    data: [],
    logListParams: {
        page: 1,
        per_page: 25,
        total: 0
    },
    loading: false
};

const logSlice = createSlice({
    name: 'log',
    initialState,
    reducers: {
        getLogs: (state) => {
            state.loading = true;
        },
        getLogsSuccess: (state, action) => {
            const { data, total, page, per_page } = action.payload;
            state.logListParams = { page, per_page, total };
            state.data = data;
            state.loading = false;
        },
        getLogsFailed: (state) => {
            state.loading = false;
        },
        createLog: (state) => {
            state.loading = true;
        },
        createLogSuccess: (state, action) => {
            state.data = [action.payload, ...state.data];
            state.loading = false;
        },
        createLogFailed: (state) => {
            state.loading = false;
        },
        clearLogs: (state) => {
            state.loading = true;
        },
        clearLogsSuccess: (state) => {
            state.data = [];
            state.loading = false;
        },
        clearLogsFailed: (state) => {
            state.loading = false;
        }
    }
});

export const {
    getLogs,
    getLogsSuccess,
    getLogsFailed,
    createLog,
    createLogSuccess,
    createLogFailed,
    clearLogs,
    clearLogsSuccess,
    clearLogsFailed
} = logSlice.actions;

export default logSlice.reducer; 